import Request from "./request";

const Industry = "/industry";

export default {
  async getIndustry(query) {
    return Request.get(Industry, query);
  }
};
